module.exports = __webpack_public_path__ + "static/media/firefox-desktop-step-1.89a542e5.png";